module.exports = __webpack_public_path__ + "static/img/IMG_20241023_114854.d83f0a26.jpg";